<template>
  <v-dialog ref="dialog" v-model="open" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-btn icon x-small text v-on="on"><v-icon>mdi-clock-time-four-outline</v-icon></v-btn>
    </template>

    <v-time-picker v-if="open" full-width format="24hr" :value="value" @click:hour="onClickHour" @change="onChange">
      <v-btn text color="primary" :disabled="!time" @click="onSave">
        OK
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="open = false">
        Отмена
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: "TimePikerDialog",

  props: {
    value: {},
  },

  data() {
    return {
      open: false,
      time: null,
    };
  },

  methods: {
    updateValue() {
      this.$emit("input", this.time);
    },

    onClickHour() {
      this.time = null;
      this.updateValue();
    },

    onChange($event) {
      this.time = $event;
    },

    onSave() {
      this.updateValue();
      this.$refs.dialog.save(this.time);
    },
  },
};
</script>

<style scoped></style>
